import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FindCustomerResult, CreateVehicle, CreateCustomer, CustomersService, VehiclesService, UpdateVehicle } from 'src/app/Api_Module';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-create-vehicle-modal',
  templateUrl: './create-vehicle-modal.component.html',
})
export class CreateVehicleModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() customer?: FindCustomerResult;
  @Input() vehicle?: UpdateVehicle;

  updateMode: boolean ;

  titles: string[];
  loading: boolean;
  alert: any;

  @Output() success: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: NgbModal, private vehiclesService: VehiclesService, private toastrService: ToastrService) { }

  ngOnInit() {
    // empty
  }

  openLg(content) {
    this.modalService.open(content, { size: 'lg' });
    if (!!this.vehicle && this.vehicle.id > 0) {
      this.updateMode = true;
    } else {
      this.vehicle = {registration: '', model: '', color: '', customerId: this.customer.id, make: '', id: null };
      this.updateMode = false;
    }
  }

  create() {
    this.vehicle.registration = this.vehicle.registration ? this.vehicle.registration.toUpperCase() : this.vehicle.registration;
    this.vehiclesService.post(this.vehicle).subscribe((resp) => {
      this.loading = false;
      this.success.emit({selected: [this.customer]});
      this.toastrService.success('Vehicle Created!');
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.customerId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastrService.error('Something went wrong. `-' + JSON.stringify(error.error) + '`');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  update() {
    this.vehicle.registration = this.vehicle.registration ? this.vehicle.registration.toUpperCase() : this.vehicle.registration;
    this.vehiclesService.put(this.vehicle).subscribe((resp) => {
      this.loading = false;
      this.success.emit({selected: [this.customer]});
      this.toastrService.success('Vehicle Updated!');
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.customerId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastrService.error('Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  close(alert: any) {
    this.alert = null;
  }
}
